import React from 'react';
import { FaThumbsUp } from "react-icons/fa";
import "./Preloader.css";


const Preloader = () => {
  return (
    <div className="like-preloader">
        <FaThumbsUp className="like-icon" />
    </div>
  )
}

export default Preloader
